import { historyList } from '../App';

export function getHistory(steps) {
    const prevPage = historyList.slice(-steps)[0];

    if (prevPage === window.location.pathname) return '/';

    return prevPage;
}
